<template>
  <v-form @submit.prevent="modal = true" v-model="formValid">
    <v-select
      :items="coinList"
      :placeholder="$t('withdraw.crypto')"
      outlined
      item-text="unit"
      :menu-props="{ bottom: true, offsetY: true }"
      @change="onChangeCoin"
      v-model="formInline.coin"
    ></v-select>

    <div class="text-light font-Regular-12 pb-2" style="text-align: end">
      {{ $t("withdraw.availableBalance") }}： {{ formInline.coin }}
      {{ $thousandMask(balance) }}
    </div>
    <v-text-field
      v-model="formInline.amount"
      :rules="amountRules"
      :placeholder="$t('withdraw.cryptoAmount')"
      name="amount"
      type="text"
      outlined
      color="primaryX"
      id="amount"
      background-color="var(--v-field-base)"
      @input="setAmount"
    >
      <template v-slot:append>
        <span
          class="total-balance-btn pr-2 pl-2 text-yellow font-Medium-12 cursor-pointer"
          @click="setTotalBalance"
          >{{ $t("withdraw.all") }}</span
        >
      </template>
    </v-text-field>

    <div class="text-end">
      <v-btn
        class="px-7"
        color="primary"
        height="50"
        depressed
        type="submit"
        :block="$vuetify.breakpoint.mdAndDown"
        :disabled="!formValid"
      >
        <span class="font-Medium-14"> {{ $t("withdraw.transfer") }}</span>
      </v-btn>
    </div>

    <v-dialog v-model="modal" width="500">
      <v-card>
        <v-card-title class="text-center d-block">
          {{ $t("withdraw.confirmTransfer") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="font-Regular-14 my-5 pb-0">
          {{ $t("withdraw.approvedTransfer") }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            :loading="withdrawLoading"
            class="font-Medium-14"
            color="primary"
            @click="withdrawRequest"
            >{{ $t("withdraw.confirm") }}</v-btn
          >
          <v-btn class="font-Medium-14 ms-2" @click="modal = false">{{
            $t("withdraw.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import { UserCenterService } from "@/services";
export default {
  name: "withdrawForm",
  mixins: [$thousandMask],
  data() {
    return {
      formValid: false,
      withdrawLoading: false,
      modal: false,
      balance: 0,
      formattedBalance: "0",
      isUserFundsVerified: false,
      amountRules: [
        () => !!this.formInline.amount || this.$t("withdraw.enterAmount"),
        v => {
          if (!v) return true;
          return (
            parseFloat(v.replace(/,/gi, "")) <= this.balance ||
            this.$t("withdraw.insufficientBalance")
          );
        }
      ],
      formInline: {
        coin: "",
        amount: ""
      },
      coinList: [],
      withdrawScale: 0
    };
  },
  mounted() {
    if (this.$route.query.name) {
      this.formInline.coin = this.$route.query.name;
    }
    this.getUserWallet();
  },
  methods: {
    getUserWallet() {
      UserCenterService.getWallet().then(res => {
        this.coinList = res.data.data.filter(coin => coin.canTransfer === 1);
        this.updateBalanceAndScale();
      });
    },
    onChangeCoin(coin) {
      if (coin) {
        this.$router.replace("/withdraw?name=" + coin, () => {});
        this.updateBalanceAndScale();
        this.formInline.amount = "";
      }
    },
    updateBalanceAndScale() {
      const currentCoin = this.coinList.find(
        c => c.unit === this.formInline.coin
      );
      if (currentCoin) {
        this.balance = parseFloat(currentCoin.strBalance || 0);
        this.withdrawScale = currentCoin.withdrawScale || 0;
        this.formattedBalance = this.$thousandMask(
          this.balance.toFixed(this.withdrawScale)
        );
      } else {
        this.balance = 0;
        this.withdrawScale = 0;
        this.formattedBalance = "0";
      }
    },
    setAmount() {
      if (!this.formInline.amount) return;
      const str = this.formInline.amount.toString();
      let number = str.replace(/,/gi, "");
      this.formInline.amount = this.$thousandMask(number, this.withdrawScale);
    },
    setTotalBalance() {
      this.formInline.amount = this.formattedBalance;
    },
    withdrawRequest() {
      this.withdrawLoading = true;

      let payload = {
        unit: this.formInline.coin,
        amount: this.formInline.amount.replace(/,/gi, ""),
        transactionType: 18
      };

      UserCenterService.applyWithdraw(payload)
        .then(response => {
          const code = response.data.code;
          code === 0 && this.$toast.success(response.data.message);
          this.getUserWallet();
          this.$emit("getList");
          this.formInline = {
            coin: "",
            amount: ""
          };
          if (this.$route.query.name) {
            this.formInline = {
              ...this.formInline,
              coin: this.$route.query.name
            };
          }
        })
        .catch(err => {
          this.$toast.error(err.message);
        })
        .finally(() => {
          this.modal = false;
          this.withdrawLoading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss"></style>
